import Vue from "vue";


Vue.filter('hours', function (value) {
    let hours = value / 60;
    let rHours = Math.floor(hours);
    let minutes = (hours - rHours) * 60;
    let rMinutes = Math.round(minutes);

    return `${rHours > 10 ? rHours : '0' + rHours}:${rMinutes > 10 ? rMinutes : '0' + rMinutes} h`;
});